import React from 'react';
import { useRef } from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import fetch from 'unfetch';
import ReactSelect from 'react-select/async';

import { parseGeoCoderResult, getSuggestUrl, getGeoCodingUrl } from './utils';
import reactSelectStyles from '../CustomReactSelect/styles';
import DropdownIndicator from '../CustomReactSelect/DropdownIndicator';
import ClearIndicator from '../CustomReactSelect/ClearIndicator';
import SearchPresets from '../SearchPresets';

const StyledReactSelect = styled(ReactSelect)`
  ${reactSelectStyles}
`;

const Wrapper = styled.div``;

const GeocoderTitle = styled.div`
  font-weight: 700;
`;

const Geocoder = (props) => {
  const { title, presets = [], presetsTitle = '' } = props;
  const selectContainer = useRef();

  const loadOptions = async (inputValue) => {
    const requestUrl = getSuggestUrl({
      query: inputValue,
      app_id: props.hereAppId,
      app_code: props.hereAppCode,
      country: props.country,
      prox: props.center,
      radius: props.radius,
      mapview: props.mapview,
      langauge: 'de',
    });

    const response = await fetch(requestUrl);
    const options = await response.json();
    return parseGeoCoderResult(options);
  };

  const handleSelect = async (option) => {
    if (!option) {
      return false;
    }

    const requestUrl = getGeoCodingUrl({
      locationId: option.locationId,
      app_id: props.hereAppId,
      app_code: props.hereAppCode,
    });

    const response = await fetch(requestUrl);
    const result = await response.json();

    props.onSelect(result);
  };

  const onPresetClick = (preset) => {
    selectContainer.select.select.setValue({
      __label: preset.name,
      locationId: preset.locationId,
    });
  };

  return (
    <Wrapper>
      {title && <GeocoderTitle>{title}</GeocoderTitle>}
      <StyledReactSelect
        ref={selectContainer}
        loadOptions={(inputValue) => loadOptions(inputValue)}
        getOptionLabel={(option) => option.__label}
        cacheOptions
        isClearable
        openMenuOnClick={false}
        openMenuOnFocus={false}
        onBlurResetsInput={false}
        onChange={(option) => handleSelect(option)}
        placeholder={props.placeholder}
        classNamePrefix="react-select"
        noOptionsMessage={(input) => {
          if (!input.inputValue || input.inputValue.length < 2) {
            return null;
          }

          return props.notFoundMessage;
        }}
        components={{
          DropdownIndicator,
          ClearIndicator,
          IndicatorSeparator: () => null,
        }}
      />
      <SearchPresets presets={presets} onClick={(p) => onPresetClick(p)} title={presetsTitle} />
    </Wrapper>
  );
};

Geocoder.displayName = 'Geocoder';

Geocoder.propTypes = {
  title: PropTypes.string,
  presetsTitle: PropTypes.string,
  presets: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
    })
  ),
  hereAppId: PropTypes.string,
  hereAppCode: PropTypes.string,
  center: PropTypes.arrayOf(PropTypes.number),
  country: PropTypes.string,
  radius: PropTypes.number,
  mapview: PropTypes.any,
  onSelect: PropTypes.func,
  notFoundMessage: PropTypes.string,
  placeholder: PropTypes.string,
};

// https://developer.here.com/documentation/geocoder-autocomplete/topics/resource-suggest.html
Geocoder.defaultProps = {
  presets: [],
  presetsTitle: '',
  hereAppId: 'z3eX9853o6uIeqWeqrGA',
  hereAppCode: 'nw1bJwSGczJRGF5I-p-wkA',
  country: 'DEU',
  radius: 2500,
  mapview: null,
  onSelect: () => {},
  notFoundMessage: 'Adresse konnte nicht gefunden werden.',
  placeholder: 'Geben Sie eine Adresse ein...',
  title: null,
};

export default Geocoder;
